export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/go-icon.svg?d23a4b881abf2128ae246ab1ef33636a";